import React, { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { FooterButton } from "./style";
import { PrinterIcon } from "../components/Icons";
import { FormattedMessage } from "react-intl";
import PurchaseReceipt from "../components/PurchaseReceipt";

const PrintableComponent = () => {
  const contentRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef,
    preserveAfterPrint: false,
    suppressErrors: true,
  });

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "p" || event.key === "P") {
        event.preventDefault();
        handlePrint();
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => document.removeEventListener("keydown", handleKeyPress);
  }, [handlePrint]);

  return (
    <>
      <div style={{ display: "none" }}>
        <div ref={contentRef}>
          <PurchaseReceipt />
        </div>
      </div>
      <FooterButton print onClick={handlePrint}>
        <PrinterIcon />
        <FormattedMessage id="print" />
        <span>(P)</span>
      </FooterButton>
    </>
  );
};

export default PrintableComponent;
